module.exports = __webpack_public_path__ + "img/arrow5.337fa8ec.png";